const getHelpCategoryUrl = (category: string) =>
  `${import.meta.env.VITE_DMM_HELP_URL}/${category}`;

const getHelpSubcategoryUrl = (
  category: string,
  subcategoryId: number,
): string => `${getHelpCategoryUrl(category)}/subcategory/${subcategoryId}`;

export const getHelpArticleUrl = (
  category: string,
  articleId: number,
): string => `${getHelpCategoryUrl(category)}/article/${articleId}`;

export const keirinHelpUrl = getHelpCategoryUrl('keirin');
export const toretaHelpUrl = getHelpSubcategoryUrl('payment', 917);

export const getKeirinHelpSubcategoryUrl = (subcategoryId: number): string =>
  getHelpSubcategoryUrl('keirin', subcategoryId);

export const getKeirinHelpArticleUrl = (articleId: number): string =>
  getHelpArticleUrl('keirin', articleId);
export const getToretaHelpArticleUrl = (articleId: number): string =>
  getHelpArticleUrl('payment', articleId);
